export enum Pathname {
  "ABOUT-US" = "about-us",
  "CONTACTS" = "contacts",
  "PORTFOLIO" = "portfolio",
}
